import { createAsyncThunk } from '@reduxjs/toolkit';
import { TeamDto } from 'dtos/team.dto';
import { SuccessDto } from 'dtos/success.dto';
import ApiClient from 'lib/api/ApiClient';
import { resolveWebV1ApiRoot } from 'v5/api/enterprise/enterprise.api.http.utils';
import {
  FEATURE_FLAGS_WIRE_KEY,
  parseFeatureFlagsResponse,
  toLegacyFeatureFlagNames
} from './featureFlags.bridge';
import { TEAMS_ACTIONS } from './teams.constants';

const isV2 = true;
const token = true;
const client = new ApiClient() as any;

const getAccountTeams = createAsyncThunk(
  TEAMS_ACTIONS.getAccountTeams,
  async () => {
    // Always /web/v1/auth — Nest v2 omits workspace feature-flag rows. Same URL as
    // EnterpriseFeatureFlagApi.getFlagSet so both loaders see one wire shape.
    const { data } = await client.get(
      `${resolveWebV1ApiRoot()}/auth/account/teams`,
      { token }
    );
    const teams = data as TeamDto[];

    // Collapse wire flags to legacy string[] on the team model. Stash the full
    // wire under FEATURE_FLAGS_WIRE_KEY so EnterpriseFeatureFlagService can seed
    // TanStack from teams/getAccountTeams/fulfilled (workspace rows would be lost
    // if we only kept the collapsed legacy list).
    return teams.map(team => {
      const wire = parseFeatureFlagsResponse(team.featureFlags);
      return {
        ...team,
        featureFlags: toLegacyFeatureFlagNames(wire),
        [FEATURE_FLAGS_WIRE_KEY]: wire
      };
    }) as TeamDto[];
  }
);

const assignUserGroupToTeam = createAsyncThunk(
  TEAMS_ACTIONS.assignUserGroupToTeam,
  async (id: string) =>
    (await client.post(`/auth/teams/:app_id:/user-groups/${id}`, {
      isV2,
      token
    })) as SuccessDto
);

export { getAccountTeams, assignUserGroupToTeam };
